import { SocketActionType } from './actions'
import * as AT from './actionTypes'
import { WebSocketWrapper } from './types'

export type SocketStateType = WebSocketWrapper | null
const socket = (state: SocketStateType = null, action: SocketActionType): SocketStateType => {
  switch (action.type) {
    case AT.SET_CONNECTION: {
      return action.payload
    }

    default:
      return state
  }
}

export default socket
